import _ from 'underscore';

/**
 * Base class for actions corresponding to the BaseRestStore.
 */
class BaseRestActions {

    constructor() {
        // Actions used internally by this class and by the BaseListStore:
        this.generateActions(
            'actionFailed',
            'actionSuccess'
        );
    }

    /**
     * Start action
     * @param {RestAction} action
     * @returns {RestAction}
     */
    actionStart(action) {
        return action;
    }

    /**
     * Read in record list
     * @param settings Optional object, can contain fields:
     *      pageSize
     *      firstRecord
     *      sort
     * @returns {*}
     */
    getCollection(settings) {
        if (settings === undefined) settings = {};
        return settings;
    }

    /**
     * Set filter
     * @param filter Object with field names and values
     * @returns {*}
     */
    setFilter(filter) {
        return filter;
    }

    /**
     * Set page size
     * @param size New size. If size is zero then all records will be read in
     * @returns {*}
     */
    setPageSize(size) {
        return size;
    }

    /**
     * Go to specified record number
     * @param {number} recNo
     * @returns {*}
     */
    gotoRecord(recNo) {
        return recNo;
    }

    /**
     * Set sort fields information
     * @param {array} sort
     * @returns {*}
     */
    setSort(sort) {
        return sort;
    }

    /**
     * Read row with the specified ID
     * @param {string} id
     * @returns {*}
     */
    get(id) {
        return id;
    }

    /**
     * Add new row to the list
     * @param {Object} row
     * @returns {*}
     */
    post(row) {
        return row;
    }

    /**
     * Remove row with the specified ID from the list
     * @param {string} id
     * @returns {*}
     */
    del(id) {
        return id;
    }

    /**
     * Update row. Row should countain "id" field.
     * @param {string} id
     * @param {Object} row
     * @returns {*}
     */
    put(id, row) {
        return {id: id, row: row};
    }

    /**
     * Clears current record collection data
     * @returns {null}
     */
    clearCollection() {
        return null;
    }

    /**
     * Clears current record data
     * @returns {null}
     */
    clearCurrentRecord() {
        return null;
    }

    /**
     * Set specified data as current record data
     * @param record
     * @return {Object}
     */
    setCurrentRecord(record) {
        return record;
    }

    /**
     * Modifies current record based by provided data
     * @param record
     * @returns {Object}
     */
    modifyCurrentRecord(record) {
        return record;
    }

    /**
     * Copies current record data to edit record buffer for editing.
     * @returns {null}
     */
    editCurrentRecord() {
        return null;
    }

    /**
     * Saves current record and marks record as saved (that is - clears record modification flag)
     * @returns {null}
     */
    saveCurrentRecord() {
        return null;
    }

    /**
     * Modifies currently edited record data. Only specified object keys will be altered.
     * @param {Object} record New record data
     * @param {boolean} changedFlag Set changed status of record. Default is true. If false then current changed status will not be changed
     */
    modifyEditRecord(record, changedFlag=true) {
        return {editRecord: record, editRecordIsChanged: changedFlag};
    }

    /**
     * Sets currently edited record data.
     * @param {Object} record New record data
     * @param {boolean} changedFlag Set changed status of record. Default is true. If false then current changed status will not be changed
     */
    setEditRecord(record, changedFlag=true) {
        return {editRecord: record, editRecordIsChanged: changedFlag};
    }

    setEditErrors(editErrors) {
        return editErrors;
    }

    setErrorFlag() {
        return null;
    }

    clearErrorFlag() {
        return null;
    }

    /**
     * Clears currently edited record data (sets record value to null).
     * @returns {null}
     */
    clearEditRecord() {
        return null;
    }

    clearEditRecordChangedFlag() {
        return null;
    }
}

export default BaseRestActions;
